import Vue from "vue";
import App from "./App.vue";
import router from "@/common/router";
import store from "@/common/store";
import "@/common/configurations/axios";
import i18n from "@/common/translations/i18n.js";
import VueCryptojs from "vue-cryptojs";
// import VueAnalytics from "vue-analytics";
import VueSweetalert2 from "vue-sweetalert2";
import 'animate.css';
import VueVirtualScroller from 'vue-virtual-scroller'
import VueGtag from 'vue-gtag';
import VueTour from 'vue-tour'
// import wysiwyg from "vue-wysiwyg";

import "@/common/assets/css/main.scss";
import 'vue-tour/dist/vue-tour.css';

import 'regenerator-runtime/runtime';

// Scroll Animations
import AOS from "aos";
import "aos/dist/aos.css";

const animations = new AOS.init({once: true});



// If you don't need the styles, do not connect
import "sweetalert2/dist/sweetalert2.min.css";
import CKEditor from "@ckeditor/ckeditor5-vue2";
// import "vue-wysiwyg/dist/vueWysiwyg.css";

Vue.use(VueVirtualScroller);

Vue.use(CKEditor);
// Vue.use(wysiwyg, {});
Vue.use(VueSweetalert2);

Vue.use(VueCryptojs);

Vue.use(VueTour);

import Vue2Editor from "vue2-editor";

// Configuration VueAnalytics
// const useAnalytics = (process.env.VUE_APP_USE_ANALYTICS === "false" ? false : true);
// Vue.use(VueAnalytics, {
//     id: "345436537",
//     router,
//     debug: {
//         sendHitTask: useAnalytics
//     }
// });

import GopNotification from '@/gop-redesign/services/gopNotifications';
Vue.use(GopNotification);

Vue.use(Vue2Editor);

Vue.use(VueGtag, {
	config: {
		//id: process.env.NODE_ENV === "production" ? 'UA-179048107-1' :"",
		id: process.env.NODE_ENV === "production" ? 'G-C5BY54448X' : "",
	}
}, router);

Vue.config.productionTip = false;

Vue.mixin({
    methods: {
        hasPermission: (permission) => store.getters.getUser?.permissions?.includes(permission),
        showNotification(message, type) {
            store.dispatch('addNotification', {type: type.toLowerCase(), message: message});
        }
    }
});

new Vue({
    router,
    store,
    i18n,
    animations,
    render: (h) => h(App),
}).$mount("#app");

